import { useState, useEffect } from "react";

import { getAdminAuthToken } from "../../../../auth/auth";
import { API_BASE_URL, profileImgSrc, base_url } from "../../../../config";
import Loader from "../../../../components/Loader";
import { useNavigate, useParams } from "react-router-dom";

export default function SelectCandidates() {
  const navigate = useNavigate();
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [roleFilter, setRoleFilter] = useState("");
  const [availabilityFilter, setAvailabilityFilter] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const [isSelecting, setIsSelecting] = useState(false);
  const params = useParams();

  const token = getAdminAuthToken();

  const fetchCandidates = async (
    filterText = "",
    roleFilter = "",
    availabilityFilter = "",
    page = 1
  ) => {
    setIsLoading(true);

    const queryParams = new URLSearchParams();
    if (filterText.trim()) queryParams.append("name", filterText);
    if (roleFilter.trim()) queryParams.append("role", roleFilter);
    if (availabilityFilter)
      queryParams.append("availability", availabilityFilter);
    queryParams.append("page", page);

    const response = await fetch(
      `${API_BASE_URL}/admin/jobs/select-candidates/${
        params.id
      }?${params.toString()}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const result = await response.json();

    if (result.success) {
      setCandidates(result.data);
      setPagination(result.meta);
      setIsLoading(false);
    } else {
      setCandidates([]);
      return { error: result.message || "Failed to fetch employees" };
    }
  };

  useEffect(() => {
    fetchCandidates();
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchCandidates(filterText, roleFilter, availabilityFilter, page);
    }, 1500);

    return () => clearTimeout(delay);
  }, [filterText, roleFilter, availabilityFilter, page]);

  const handleSelectCanditates = (candidate) => {
    const existingCandidate = selectedCandidates.includes(candidate.id);

    let updatedList;

    if (existingCandidate) {
      updatedList = selectedCandidates.filter((id) => id !== candidate.id);
    } else {
      updatedList = [...selectedCandidates, candidate.id];
    }

    setSelectedCandidates(updatedList);
  };

  const handleSubmitCandidates = async () => {
    setIsSelecting(true);

    const response = await fetch(
      `${API_BASE_URL}/admin/jobs/${params.id}/candidates`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ candidates: selectedCandidates }),
      }
    );

    const result = await response.json();

    if (response.success === false) {
      return { error: result.message || "Failed to select candidates" };
    }

    setIsSelecting(false);
    navigate(`/admin/jobs/edit-company-job/${params.id}`);
  };

  return (
    <>
      <h2>Select Candidates</h2>
      <div className="select-candidate-filters-wrapper dash-filter-wrapper-all">
        <div className="dash-filter-wrapper-all__fields">
          <div className="dash-filter-wrapper-all__fields--search">
            <label>Filter by Name</label>
            <input
              type="search"
              placeholder="Search"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
            ></input>
          </div>
          <div className="select-candidate__fields--select dash-filter-wrapper-all__fields--select">
            <div className="form-group">
              <label>Filter by Role</label>
              <input
                type="search"
                placeholder="Search"
                value={roleFilter}
                onChange={(e) => setRoleFilter(e.target.value)}
              ></input>
            </div>
          </div>
          <div className="select-candidate__fields--select dash-filter-wrapper-all__fields--select">
            <div className="form-group">
              <label>Availability</label>
              <select
                onChange={(e) => setAvailabilityFilter(e.target.value)}
                value={availabilityFilter}
              >
                <option value="">All</option>
                <option value="1">Available for work</option>
                <option value="0">Not available for work</option>
              </select>
            </div>
          </div>
        </div>
        <div className="select-candidate__new--job dash-filter-wrapper-all__right">
          <div className="selected-candidates">
            <button
              onClick={handleSubmitCandidates}
              disabled={selectedCandidates.length === 0}
              className={`${isSelecting ? "blink-disabled" : ""} `}
            >
              {isSelecting
                ? "Selecting..."
                : `Select ${selectedCandidates.length}`}
            </button>
          </div>
        </div>
      </div>
      <div className="candidates-all-wrapper">
        {isLoading ? (
          <Loader />
        ) : (
          <div className="card-single-wrapper candidates-single-wrapper">
            {candidates.length > 0 ? (
              <div className="row-essy">
                {candidates?.map((curr, index) => {
                  const isSelected = selectedCandidates.some(
                    (selected) => selected === curr.id
                  );
                  return (
                    <div className="col-essy-lg-3 col-essy-md-4" key={index}>
                      <div
                        className={`candidates-all-single ${
                          isSelected ? "active" : ""
                        }`}
                        onClick={() => handleSelectCanditates(curr)}
                      >
                        <div className="candidates-all-single__profile">
                          <div className="candidates-all-single__profile--img">
                            <img
                              src={
                                curr.avatar === null
                                  ? profileImgSrc
                                  : `${base_url}${curr.avatar}`
                              }
                              alt="profile img"
                            />
                          </div>
                          <div className="candidates-all-single__profile--verified">
                            {curr?.verified ? (
                              <>
                                Verified
                                <svg
                                  width="20"
                                  height="21"
                                  viewBox="0 0 20 21"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <circle
                                    cx="9.90643"
                                    cy="9.90643"
                                    r="7.37714"
                                    fill="white"
                                  />
                                  <path
                                    d="M18.4161 10.3448C18.3466 10.1278 18.3466 9.8938 18.4161 9.6767L19.0969 7.58594C19.2402 7.14123 19.0821 6.65227 18.7028 6.37827L16.9239 5.08417C16.7405 4.95139 16.6015 4.76169 16.5319 4.54463L15.8511 2.45173C15.7078 2.00702 15.2926 1.70561 14.8226 1.70561H12.6243C12.3967 1.70561 12.1733 1.63396 11.9878 1.49907L10.209 0.207085C9.83169 -0.0690283 9.31744 -0.0690283 8.94016 0.207085L7.15921 1.49907C6.97582 1.63396 6.75243 1.70561 6.52481 1.70561H4.32445C3.85653 1.70561 3.44133 2.00702 3.298 2.45384L2.61724 4.54463C2.54767 4.76169 2.40858 4.95139 2.22311 5.08628L0.446354 6.37827C0.0669938 6.65227 -0.0910792 7.14123 0.0522517 7.58594L0.733016 9.6767C0.802559 9.8938 0.802559 10.1278 0.733016 10.3448L0.0522517 12.4377C-0.0910793 12.8824 0.0669938 13.3714 0.446354 13.6454L2.22522 14.9374C2.40858 15.0723 2.54558 15.262 2.61724 15.479L3.29589 17.5698C3.44133 18.0167 3.85653 18.318 4.32445 18.318H6.52481C6.75243 18.318 6.97371 18.3897 7.15921 18.5225L8.94016 19.8166C9.31744 20.0927 9.83169 20.0927 10.209 19.8166L11.9899 18.5225C12.1733 18.3897 12.3967 18.318 12.6243 18.318H14.8247C15.2926 18.318 15.7078 18.0167 15.8511 17.5698L16.5319 15.479C16.6015 15.262 16.7405 15.0723 16.9239 14.9374L18.7028 13.6454C19.0821 13.3714 19.2402 12.8824 19.0969 12.4377L18.4161 10.3448ZM13.9964 7.9316C13.9964 8.20979 13.8868 8.47114 13.6908 8.66716L9.53453 12.8213C9.34692 13.0089 9.08136 13.1164 8.80318 13.1164C8.52496 13.1164 8.25729 13.0089 8.0697 12.8213L5.45411 10.2099C5.05157 9.8074 5.05157 9.14979 5.452 8.74303C5.84616 8.34891 6.53114 8.34891 6.92313 8.74092L8.80107 10.6188L12.2218 7.19811C12.6159 6.81034 13.303 6.81034 13.6908 7.19811C13.8868 7.39414 13.9964 7.65551 13.9964 7.9316Z"
                                    fill="#28DDCF"
                                  />
                                </svg>
                              </>
                            ) : (
                              <span>Not verified.</span>
                            )}
                          </div>
                        </div>
                        <h4>{curr.name}</h4>
                        <p>{curr.current_role}</p>
                        <div className="separator"></div>
                        <div className="candidates-all-single__skill">
                          {curr.skills.map((currSkill) => (
                            <span key={currSkill.id}>{currSkill.name}</span>
                          ))}
                        </div>
                        <div className="candidates-all-single__availability">
                          {curr.availability === 1 ? (
                            <>
                              <svg
                                width="8"
                                height="8"
                                viewBox="0 0 8 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx="4" cy="4" r="2" fill="#28DDCF" />
                                <circle
                                  cx="4"
                                  cy="4"
                                  r="4"
                                  fill="#28DDCF"
                                  fillOpacity="0.2"
                                />
                              </svg>
                              Available For Work
                            </>
                          ) : (
                            <>
                              <svg
                                width="8"
                                height="8"
                                viewBox="0 0 8 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx="4" cy="4" r="2" fill="#FF6633" />
                                <circle
                                  cx="4"
                                  cy="4"
                                  r="4"
                                  fill="#FF6633"
                                  fillOpacity="0.2"
                                />
                              </svg>
                              Already Hired
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="job-card__not-found">No candidates found.</div>
            )}
          </div>
        )}
      </div>
      <div className="job-dashboard-pagination pagination-all">
        {Array.from({ length: pagination.last_page }, (_, i) => i + 1).map(
          (num) => (
            <button
              key={num}
              className={num === pagination.current_page ? "active" : ""}
              onClick={() => setPage(num)}
            >
              {num}
            </button>
          )
        )}
      </div>
    </>
  );
}
